import {lazy} from 'react'

const AccountSettings = lazy(() => import('../../pages/account-settings'))
const Dashboard = lazy(() => import('../../pages/dashboard'))
const Parking = lazy(() => import('../../pages/administration/parking/Parking'))
const User = lazy(() => import('../../pages/administration/user/UserList'))
const SymfonyLog = lazy(() => import('../../pages/administration/log/SymfonyLog'))
const SystemLog = lazy(() => import('../../pages/administration/log/SystemLog'))
const PylonMessage = lazy(() => import('../../pages/parking/pylon/PylonMessage'))
const WhiteVehicles = lazy(() => import('../../pages/parking/white-vehicles/WhiteVehicles'))
const PriceList = lazy(() => import('../../pages/parking/price-list/PriceList'))
const Discount = lazy(() => import('../../pages/parking/discount/DiscountList'))
const ParkingOperator = lazy(() => import('../../pages/parking/parking-operator/ParkingOperator'))
const NewReservation = lazy(() => import('../../pages/reservation/new-reservation/NewReservation'))
const ReservationList = lazy(() => import('../../pages/reservation/management/list/ReservationList'))
const EntryExitReport = lazy(() => import('../../pages/report/entry-exit-event-report/EntryExitReport'))
const GateEventReport = lazy(() => import('../../pages/report/gate-event-report/GateEventReport'))
const DriverLoadReport = lazy(() => import('../../pages/report/driver-load-raport/DriverLoadReport'))
const ParkingLoadReport = lazy(() => import('../../pages/report/parking-load-raport/ParkingLoadReport'))
const ManagerReport = lazy(() => import('../../pages/report/manager-report/ManagerReport'))
const CustomerLocationReport = lazy(() => import('../../pages/report/customer-location-raport/CustomerLocationReport'))
const UserReservationList = lazy(() => import('../../pages/reservation/reservation-list/ReservationList'))
const ReservationPayment = lazy(() => import('../../pages/reservation/new-reservation/ReservationPayment'))
const ReservationPaymentManager = lazy(() => import('../../pages/reservation/management/list/ReservationPayment'))

const PagesRoutes = [
    {
        path: '/user/account',
        element: <AccountSettings/>,
        meta: {
            action: 'ROLE_USER',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/dashboard',
        element: <Dashboard/>,
        meta: {
            action: 'ROLE_USER',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/administration/parking',
        element: <Parking/>,
        meta: {
            action: 'ROLE_ADMINISTRATION_PARKING',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/administration/users',
        element: <User/>,
        meta: {
            action: 'ROLE_ADMINISTRATION_USER',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/administration/log/symfony-log',
        element: <SymfonyLog/>,
        meta: {
            action: 'ROLE_ADMINISTRATION_LOGS_SYMFONY',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/administration/log/system-log',
        element: <SystemLog/>,
        meta: {
            action: 'ROLE_ADMINISTRATION_LOGS_SYSTEM',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/parking/pylon-message',
        element: <PylonMessage/>,
        meta: {
            action: 'ROLE_PARKING_PYLON_MESSAGE',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/parking/white-vehicles',
        element: <WhiteVehicles/>,
        meta: {
            action: 'ROLE_PARKING_WHITE_VEHICLES',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/parking/price-list',
        element: <PriceList/>,
        meta: {
            action: 'ROLE_PARKING_PRICE_LIST',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/parking/discount',
        element: <Discount/>,
        meta: {
            action: 'ROLE_PARKING_DISCOUNT',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/parking/parking-operator',
        element: <ParkingOperator/>,
        meta: {
            action: 'ROLE_PARKING_OPERATOR',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/reservation/new',
        element: <NewReservation/>,
        meta: {
            action: 'ROLE_USER',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/reservation/new/:id',
        element: <NewReservation/>,
        meta: {
            action: 'ROLE_USER',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/reservation/management/list',
        element: <ReservationList/>,
        meta: {
            action: 'ROLE_RESERVATION_MANAGEMENT_LIST',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/reservation/management/confirm/:id',
        element: <ReservationPaymentManager/>,
        meta: {
            action: 'ROLE_RESERVATION_MANAGEMENT_LIST',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/report/entry-exit',
        element: <EntryExitReport/>,
        meta: {
            action: 'ROLE_REPORT_ENTRY_EXIT_EVENT',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/report/gate-event',
        element: <GateEventReport/>,
        meta: {
            action: 'ROLE_REPORT_GATE_EVENT',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/report/driver-load',
        element: <DriverLoadReport/>,
        meta: {
            action: 'ROLE_REPORT_DRIVER_LOAD',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/report/parking-load',
        element: <ParkingLoadReport/>,
        meta: {
            action: 'ROLE_REPORT_PARKING_LOAD',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/report/customer-location',
        element: <CustomerLocationReport/>,
        meta: {
            action: 'ROLE_REPORT_CUSTOMER_LOCATION',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/report/manager',
        element: <ManagerReport/>,
        meta: {
            action: 'ROLE_REPORT_MANAGER',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/reservation/list',
        element: <UserReservationList/>,
        meta: {
            action: 'ROLE_CUSTOMER',
            resource: 'IS_GRANTED'
        }
    },
    {
        path: '/reservation/confirm/:id',
        element: <ReservationPayment/>,
        meta: {
            action: 'ROLE_CUSTOMER',
            resource: 'IS_GRANTED'
        }
    }
]

export default PagesRoutes